export default "__VITE_ASSET__FU_mskHa__"